const SELECTOR = '[data-mpp-delivery-selector]';

function getFields(root) {
  return {
    mode: root.querySelector('[data-mpp-field="mode"]'),
    zone: root.querySelector('[data-mpp-field="zone"]'),
    availability: root.querySelector('[data-mpp-field="availability"]'),
    time: root.querySelector('[data-mpp-field="time"]'),
    relay: root.querySelector('[data-mpp-field="relay"]'),
    groupOrder: root.querySelector('[data-mpp-field="group-order"]'),
    company: root.querySelector('[data-mpp-field="company"]'),
  };
}

function setActive(field, active) {
  if (!field) return;
  field.disabled = !active;
  field.required = active;
}

function isFilled(field) {
  return !field || field.disabled || String(field.value || '').trim().length > 0;
}

function selectedTourDate(zoneField) {
  return zoneField?.selectedOptions?.[0]?.dataset?.tourDate || '';
}

function isAvailableSelection(availabilityField) {
  return availabilityField?.selectedOptions?.[0]?.dataset?.mppAvailable === 'true';
}

function syncAvailability(root, resetSelection = false) {
  const fields = getFields(root);
  const date = selectedTourDate(fields.zone);
  const availableOption = fields.availability?.querySelector('[data-mpp-available="true"]');

  if (availableOption) {
    availableOption.textContent = date ? `Date de tournée : ${date}` : 'Date de tournée pour la zone sélectionnée';
    availableOption.value = date ? `Disponible — ${date}` : 'Disponible à la date de tournée';
  }

  if (resetSelection && fields.availability) {
    fields.availability.value = '';
    if (fields.time) fields.time.value = '';
  }
}

function updateSelector(root, showValidation = false) {
  const fields = getFields(root);
  const mode = fields.mode?.value || '';
  const isHome = mode === 'Livraison à domicile';
  const isRelay = mode === 'Point relais';
  const isGroup = mode === 'Commandes groupées';
  const isCompany = mode === 'Comités d’entreprise';
  const isAvailable = isAvailableSelection(fields.availability);
  const isUnavailable = fields.availability?.value === 'Je ne suis pas disponible';

  const homePanel = root.querySelector('[data-mpp-panel="home"]');
  const relayPanel = root.querySelector('[data-mpp-panel="relay"]');
  const groupPanel = root.querySelector('[data-mpp-panel="group"]');
  const companyPanel = root.querySelector('[data-mpp-panel="company"]');
  const timePanel = root.querySelector('[data-mpp-panel="time"]');
  const unavailable = root.querySelector('[data-mpp-unavailable]');

  if (homePanel) homePanel.hidden = !isHome;
  if (relayPanel) relayPanel.hidden = !isRelay;
  if (groupPanel) groupPanel.hidden = !isGroup;
  if (companyPanel) companyPanel.hidden = !isCompany;
  if (timePanel) timePanel.hidden = !(isHome && isAvailable);
  if (unavailable) unavailable.hidden = !(isHome && isUnavailable);

  setActive(fields.zone, isHome);
  setActive(fields.availability, isHome && Boolean(fields.zone?.value));
  setActive(fields.time, isHome && isAvailable);
  setActive(fields.relay, isRelay);
  setActive(fields.groupOrder, isGroup);
  setActive(fields.company, isCompany);

  const requiredFields = [fields.mode, fields.zone, fields.availability, fields.time, fields.relay, fields.groupOrder, fields.company];
  const complete = requiredFields.every(isFilled);

  const container =
    root.closest('.cart-drawer__summary, .cart-summary__inner, .cart-page__summary') || root.parentElement;
  const checkout = container?.querySelector('#checkout');
  const accelerated = container?.querySelector('.additional-checkout-buttons');
  const validation = root.querySelector('[data-mpp-validation]');

  if (checkout instanceof HTMLButtonElement) {
    checkout.disabled = !complete;
    checkout.setAttribute('aria-disabled', String(!complete));
  }

  if (accelerated instanceof HTMLElement) {
    accelerated.hidden = !complete;
  }

  if (validation) {
    validation.hidden = complete || !showValidation;
  }

  root.dataset.mppComplete = String(complete);
  return complete;
}

function attributesFor(root) {
  const fields = getFields(root);
  const mode = fields.mode?.value || '';
  const isHome = mode === 'Livraison à domicile';
  const isRelay = mode === 'Point relais';
  const isGroup = mode === 'Commandes groupées';
  const isCompany = mode === 'Comités d’entreprise';
  const isAvailable = isAvailableSelection(fields.availability);
  const tourDate = isHome ? selectedTourDate(fields.zone) : '';

  return {
    'Mode de réception': mode,
    'Zone de livraison': isHome ? fields.zone?.value || '' : '',
    'Date de tournée': tourDate,
    'Disponibilité tournée': isHome ? fields.availability?.value || '' : '',
    'Créneau de livraison': isHome && isAvailable ? fields.time?.value || '' : '',
    'Point relais': isRelay ? fields.relay?.value || '' : '',
    'Commande groupée': isGroup ? fields.groupOrder?.value || '' : '',
    'Comité d’entreprise': isCompany ? fields.company?.value?.trim() || '' : '',
    'Entreprise ou groupe': '',
  };
}

async function saveAttributes(root) {
  const shopRoot = window.Shopify?.routes?.root || '/';
  root.dataset.mppSaving = 'true';

  try {
    await fetch(`${shopRoot}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributesFor(root) }),
    });
  } catch (error) {
    console.warn('[MPP delivery] Unable to save cart attributes', error);
  } finally {
    delete root.dataset.mppSaving;
  }
}

function initialize(root) {
  if (!(root instanceof HTMLElement) || root.dataset.mppReady === 'true') return;
  root.dataset.mppReady = 'true';
  syncAvailability(root);
  updateSelector(root);
}

document.querySelectorAll(SELECTOR).forEach(initialize);

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;
  const root = target.closest(SELECTOR);
  if (!root || !target.matches('select, input')) return;

  if (target.matches('[data-mpp-field="zone"]')) {
    syncAvailability(root, true);
  }

  updateSelector(root);
  saveAttributes(root);
});

let companyTimer;
document.addEventListener('input', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLInputElement) || !target.matches('[data-mpp-field="company"]')) return;
  const root = target.closest(SELECTOR);
  if (!root) return;

  updateSelector(root);
  clearTimeout(companyTimer);
  companyTimer = setTimeout(() => saveAttributes(root), 350);
});

document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const checkout = target.closest('#checkout, .additional-checkout-buttons');
    if (!checkout) return;

    const container =
      checkout.closest('.cart-drawer__summary, .cart-summary__inner, .cart-page__summary') || document;
    const root = container.querySelector(SELECTOR);
    if (!root || updateSelector(root, true)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const firstInvalid = [...root.querySelectorAll('[required]:not([disabled])')].find((field) => !field.value);
    firstInvalid?.focus();
    firstInvalid?.reportValidity?.();
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  },
  true
);

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches(SELECTOR)) initialize(node);
      node.querySelectorAll?.(SELECTOR).forEach(initialize);
    }
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });
